import { render, staticRenderFns } from "./CreateStandaloneCompany.vue?vue&type=template&id=005c6a35&scoped=true"
import script from "./CreateStandaloneCompany.vue?vue&type=script&lang=js"
export * from "./CreateStandaloneCompany.vue?vue&type=script&lang=js"
import style0 from "./CreateStandaloneCompany.vue?vue&type=style&index=0&id=005c6a35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005c6a35",
  null
  
)

export default component.exports